import React from "react";
import * as firebase from 'firebase'
import { Button, Container, Row, Col } from "reactstrap";
import NotificationAlert from 'react-notification-alert';
import { Redirect, Route } from 'react-router'
import Header from './Header.js';
import Footer from './Footer.js';

import {
  Badge,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Table,
  CardImg,
  FormGroup,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Modal

} from "reactstrap";
import { Link } from "react-router-dom";


const serverValue = firebase.database.ServerValue;
let successNotification

class WatchDog extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
     
        totalUsers: ''

    };
  }

  loadTotalNo() {
    let advertsList
    let referalID



   
    //   this.setState({ loadingReferals: true })
    var user = firebase.auth().currentUser;
    //  var myUserId = firebase.auth().currentUser.uid;
    var usersRef = firebase.database().ref('users')
    usersRef.on('value', snapshot => {
      // dbRefObject.on('value', snapshot => {
      // convert messages list from snapshot
      const usersObject = snapshot.val();

      if (usersObject) {
      

        const adverts = Object.keys(usersObject).map(key => ({
          ...usersObject[key],
          uid: key,
        }));
        advertsList = adverts
      
      
let count = 0
for(let i = 0; i <advertsList.length;i++){
count += 1
}

this.setState({totalUsers: count})

      } else {
      
      }
    });
  }

  onClearUsersClick(){
    var answeredQuestionsRef = firebase.database().ref('users');
    answeredQuestionsRef.remove()
.then(function() {
  try{
    //this.refs.notify.notificationAlert(removedAnswered);

}
catch{
  
}

})
.catch(function(error) {
  try{
   // this.refs.notify.notificationAlert(couldnotRemoveAnswerd);

}
catch{
  
}
});

   
  }

  componentDidMount() {
    this.setState({ link: window.location.href })
    try{
      document.documentElement.scrollTop = 0;
      document.scrollingElement.scrollTop = 0;
      this.refs.main.scrollTop = 0;
    }
    catch{
        
    }
    this.loadTotalNo()
}
  render() {

  
    return (
      <>
        <Header />
        <main ref="main">







          <section className="section section-lg bg-gradient-orange" >

            {/* SVG separator */}
            <div className="separator separator-bottom separator-skew zindex-100" >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                preserveAspectRatio="none"
                version="1.1"
                viewBox="0 0 2560 100"
                x="0"
                y="0"
              >

                <polygon
                  className="fill-white"
                  points="2560 0 2560 100 0 100"
                />

              </svg>
            </div>
           

            <div className="content" style={{ backgroundColor: '#A9DFBF', marginTop: 60 }}>


              <Row>
                <Col md="12">
                  <Card>
                  <button  style={{marginTop: 20}} onClick={() => this.onClearUsersClick()} type="button" class="btn btn-success btn-block">CLEAR USERS</button>

                    <CardHeader>
                      <CardTitle tag="h4" style={{color: 'green'}}> {this.state.totalUsers} Applicants</CardTitle>
                    </CardHeader>
                    <CardBody>
                      <Table className="table-bordered" responsive>
                        <thead className="text-primary">
                          <tr style={{ backgroundColor: '#347C2C' }}>
                            <th style={{ color: 'white' }}>S/N</th>
                            <th style={{ color: 'white' }}>Name</th>
                            <th style={{ color: 'white' }}>Mobile Number</th>
                            <th style={{ color: 'white' }}>Gender</th>
                            <th style={{ color: 'white' }}>Age</th>
                            <th style={{ color: 'white' }}>State of Origin</th>
                            <th style={{ color: 'white' }}>Education Level</th>
                            <th style={{ color: 'white' }}>Amount</th>
                            <th style={{ color: 'white' }}>Date/Time</th>
                         

                          </tr>
                        </thead>
                        <TableBody />
                      </Table>
                    </CardBody>
                  </Card>
                </Col>
              </Row>


            </div>


          </section>


        </main>
        <Footer />

      </>
    );
      }
    
}

class TableBody extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingWithdrawalRequests: false,
      withdrawalRequestsAvailable: false,
      withdrawalRequests:[],
      name: '',
      viewActivity: false
    }

    // loading = this.state.loadingUserAdverts
  }

  compareValues(key, order = 'asc') {
    return function innerSort(a, b) {
      if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
        // property doesn't exist on either object
        return 0;
      }
  
      const varA = (typeof a[key] === 'string')
        ? a[key].toUpperCase() : a[key];
      const varB = (typeof b[key] === 'string')
        ? b[key].toUpperCase() : b[key];
  
      let comparison = 0;
      if (varA > varB) {
        comparison = 1;
      } else if (varA < varB) {
        comparison = -1;
      }
      return (
        (order === 'desc') ? (comparison * -1) : comparison
      );
    };
  }
  

  loadTableData() {
    let advertsList
    let referalID



    this.setState({ loadingWithdrawalRequests: true })
    //   this.setState({ loadingReferals: true })
    var user = firebase.auth().currentUser;
    //  var myUserId = firebase.auth().currentUser.uid;
    var usersRef = firebase.database().ref('users')
    usersRef.on('value', snapshot => {
      // dbRefObject.on('value', snapshot => {
      // convert messages list from snapshot
      const usersObject = snapshot.val();

      if (usersObject) {
        this.setState({ withdrawalRequestsAvailable: true })

        const adverts = Object.keys(usersObject).map(key => ({
          ...usersObject[key],
          uid: key,
        }));
        advertsList = adverts

        let data = adverts.sort(this.compareValues('dateRegistered'));

      
        this.setState({ withdrawalRequests: data.reverse(), loadingWithdrawalRequests: false })





      } else {
        this.setState({ loadingWithdrawalRequests: false })
      }
    });
  }


  componentDidMount() {


    this.loadTableData()


  }

  
  



  render() {
    let data

    //

    data = this.state.withdrawalRequests
    //  console.log(this.state.referals)

    const row = data.map((request, index) => {

      
      

     
      let requestDate = new Date(request.dateRegistered);
      //let submissionDate = referal.submissionTime
      let formattedrequestDate = requestDate.toDateString()

      let date = new Date(formattedrequestDate);
      let year = date.getFullYear()
let month = date.getMonth()+1
let day = date.getDate()

let hour = requestDate.getHours()
let minutes = requestDate.getMinutes()
let add0Hour =''
let add0Minutes =''

if(parseInt(hour)<10){
  add0Hour="0"
}
else if(parseInt(hour)>=10){
  add0Hour=""
}

if(parseInt(minutes)<10){
  add0Minutes="0"
}
else if(parseInt(minutes)>=10){
  add0Minutes=""
}

let lockOrLocked = ''
if(request.locked===true){
  lockOrLocked = 'LOCKED'
}

else if(request.locked===false || request.locked ===null || request.locked===undefined  ){
  lockOrLocked = 'LOCK'
}




  
      return (

<>


        <tr key={index}>
          <td>{++index} .</td>
      <td>{request.firstName} {request.surName}</td>
          <td>{request.mobileNumber}</td>
          <td>{request.gender}</td>
          <td>{request.age}</td>
           <td>{request.stateOfOrigin}</td>
           <td>{request.educationLevel}</td>
           <td>{request.amountApproved}</td>
          <td>{day}-{month}-{year}<br></br>({add0Hour}{hour}:{add0Minutes}{minutes})</td>
         
        </tr>
</>
      )
    })
    if (this.state.loadingWithdrawalRequests === true) {
      return <tr>
        <td><div class="spinner-border text-success"></div></td>
        <td><div class="spinner-border text-success"></div></td>
        <td><div class="spinner-border text-success"></div></td>
        <td><div class="spinner-border text-success"></div></td>
        <td><div class="spinner-border text-success"></div></td>
        <td><div class="spinner-border text-success"></div></td>
        <td><div class="spinner-border text-success"></div></td>
        <td><div class="spinner-border text-success"></div></td>

        <td><div class="spinner-border text-success"></div></td>
               
        

      </tr>

    }
    if (this.state.withdrawalRequestsAvailable === false) {
      return <p>No Users</p>


    }



    else return <tbody>
        <NotificationAlert ref="notify" />
    
      {row}
      </tbody>

  }


}

export default WatchDog;
